var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "shadow-none rounded rounded-3 flex-fill mb-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-stretch"
  }, [_c('div', {
    staticClass: "user-avatar d-flex flex-column justify-content-between"
  }, [_c('b-avatar', {
    attrs: {
      "size": "6rem",
      "src": _vm.customer.data ? _vm.customer.data.pictureUrl : _vm.customer.avatar_url
    }
  }), _vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_LIST_EDIT) ? _c('div', {
    staticClass: "text-center m-auto"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "inverse-warning",
      "to": {
        name: 'CustomerDetailEdit',
        params: {
          customerID: _vm.customer.id
        }
      }
    }
  }, [_vm._v(" 編輯 ")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "wrapper pl-4 flex-fill"
  }, [_c('div', {
    staticClass: "wrapper d-flex align-items-center justify-content-between"
  }, [_c('a', {
    class: _vm.showUnderline ? 'customer-name-underline' : 'customer-name',
    attrs: {
      "role": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.handleRedirectCustomer(_vm.customer.id);
      }
    }
  }, [_c('h4', {
    staticClass: "mb-1 text-xl font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.customer.name) + " ")])]), _vm.merchantTypeName ? [_c('span', {
    staticClass: "badge badge-primary badge-pill text-wrap",
    attrs: {
      "id": "merchant-".concat(_vm.customer.id)
    }
  }, [_vm._v(_vm._s(_vm.merchantTypeName.substring(0, 25)))]), _c('b-tooltip', {
    attrs: {
      "target": "merchant-".concat(_vm.customer.id),
      "placement": "top"
    }
  }, [_vm._v(_vm._s(_vm.merchantName))])] : _vm._e()], 2), _c('div', {
    staticClass: "\n          wrapper\n          d-flex\n          align-items-center\n          font-weight-medium\n          text-muted\n        "
  }, [_c('i', {
    staticClass: "mdi mdi-account-card-details mr-2",
    attrs: {
      "id": "icon-account-card-details-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-account-card-details-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("識別編號")]), _c('p', {
    staticClass: "mb-0 text-muted text-sm",
    staticStyle: {
      "line-break": "anywhere"
    }
  }, [_vm._v(" " + _vm._s(_vm.customer.outer_code) + " ")])], 1), _c('div', {
    staticClass: "\n          wrapper\n          d-flex\n          align-items-center\n          font-weight-medium\n          text-muted\n        "
  }, [_c('i', {
    staticClass: "mdi mdi-cellphone mr-2",
    attrs: {
      "id": "icon-cellphone-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-cellphone-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("手機")]), _c('p', {
    staticClass: "mb-0 text-muted text-sm"
  }, [_vm._v(" " + _vm._s(_vm.customer.mobile_phone) + " "), _vm.customer.phone_verified_at ? _c('span', {
    staticClass: "mdi mdi-verified",
    staticStyle: {
      "color": "#009100"
    },
    attrs: {
      "id": "icon-phone-verified"
    }
  }) : _vm._e(), _vm.customer.phone_verified_at ? _c('b-tooltip', {
    attrs: {
      "target": "icon-phone-verified",
      "placement": "right"
    }
  }, [_vm._v(" 手機驗證時間：" + _vm._s(_vm.moment(_vm.customer.phone_verified_at).format('YYYY-MM-DD HH:mm')) + " ")]) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "\n          wrapper\n          d-flex\n          align-items-center\n          font-weight-medium\n          text-muted\n        "
  }, [_c('i', {
    staticClass: "mdi mdi-email-outline mr-2",
    attrs: {
      "id": "icon-email-outline-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-email-outline-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("E-mail")]), _c('p', {
    staticClass: "mb-0 text-muted text-sm",
    staticStyle: {
      "line-break": "anywhere"
    }
  }, [_vm._v(" " + _vm._s(_vm.customer.email) + " "), _vm.isEmailVerified ? _c('span', {
    staticClass: "mdi mdi-verified",
    staticStyle: {
      "color": "#009100"
    },
    attrs: {
      "id": "icon-email-verified-".concat(_vm.customer.id)
    }
  }) : _vm._e(), _vm.isEmailVerified ? _c('b-tooltip', {
    attrs: {
      "target": "icon-email-verified-".concat(_vm.customer.id),
      "placement": "right"
    }
  }, [_vm._v(" " + _vm._s(_vm.emailVerifiedText) + " ")]) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "\n          wrapper\n          d-flex\n          align-items-center\n          font-weight-medium\n          text-muted\n        "
  }, [_c('i', {
    staticClass: "mdi mdi-gender-male-female mr-2",
    attrs: {
      "id": "icon-gender-male-female-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-gender-male-female-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("性別")]), _c('p', {
    staticClass: "mb-0 text-muted text-sm"
  }, [_vm._v(_vm._s(_vm.customer.sexual))])], 1), _c('div', {
    staticClass: "\n          wrapper\n          d-flex\n          align-items-center\n          font-weight-medium\n          text-muted\n        "
  }, [_c('i', {
    staticClass: "mdi mdi-cake-variant mr-2",
    attrs: {
      "id": "icon-cake-variant-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-cake-variant-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("生日")]), _c('p', {
    staticClass: "mb-0 text-muted text-sm"
  }, [_vm._v(_vm._s(_vm.customer.birthday ? _vm.moment(_vm.customer.birthday).format('YYYY-MM-DD') : ''))])], 1), _c('div', {
    staticClass: "\n          wrapper\n          d-flex\n          align-items-center\n          font-weight-medium\n          text-muted\n        "
  }, [_c('i', {
    staticClass: "mdi mdi-account-plus mr-2",
    attrs: {
      "id": "icon-account-plus-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-account-plus-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("加入時間")]), _c('p', {
    staticClass: "mb-0 text-muted text-sm"
  }, [_vm._v(_vm._s(_vm.customer.created_at ? _vm.moment(_vm.customer.created_at).format('YYYY-MM-DD HH:mm') : ''))])], 1), _c('div', {
    staticClass: "\n          wrapper\n          d-flex\n          align-items-center\n          font-weight-medium\n          text-muted\n        "
  }, [_c('i', {
    staticClass: "mdi mdi-account-check mr-2",
    attrs: {
      "id": "icon-account-check-".concat(_vm.customer.id)
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "icon-account-check-".concat(_vm.customer.id),
      "placement": "left"
    }
  }, [_vm._v("註冊時間")]), _c('p', {
    staticClass: "mb-0 text-muted text-sm"
  }, [_vm._v(" " + _vm._s(_vm.customer.registered_at ? _vm.moment(_vm.customer.registered_at).format('YYYY-MM-DD HH:mm') : '') + " "), _vm.customer.registered_at ? _c('span', {
    staticClass: "mdi mdi-verified",
    staticStyle: {
      "color": "#009100"
    }
  }) : _vm._e()])], 1), _c('div', {
    staticClass: "text-right mt-2"
  }, [_vm.showCanRecomputeLevel ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "inverse-success"
    },
    on: {
      "click": function click($event) {
        return _vm.recomputeLevel(_vm.customer);
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-flask-outline m-1"
  }, [_vm._v("重新計算等級")])]) : _vm._e(), _vm.merchantType == 'LINE' && _vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_LINE_SYNC) ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "inverse-success"
    },
    on: {
      "click": function click($event) {
        return _vm.handleSyncLineData(_vm.customer);
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-cloud-download"
  }), _vm._v("同步 LINE")]) : _vm._e(), _vm.merchantType == 'LINE' && _vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_CLEAR_CACHE) ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "inverse-warning"
    },
    on: {
      "click": function click($event) {
        return _vm.handleClearLiffCache(_vm.customer);
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-cloud-sync"
  }), _vm._v("清除快取")]) : _vm._e(), _vm.showQuicklyUnbind ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-1",
    attrs: {
      "variant": "outline-danger",
      "title": "重設此帳號，並解除所有綁定"
    },
    on: {
      "click": function click($event) {
        return _vm.handleQuicklyUnbind(_vm.customer);
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-link-off"
  }), _vm._v(" 快速解綁 ")]) : _vm._e(), _vm.showUnregister ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-1",
    attrs: {
      "variant": "outline-danger",
      "title": "將此帳號設定為未註冊狀態"
    },
    on: {
      "click": function click($event) {
        return _vm.handleUnregister(_vm.customer);
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-logout"
  }), _vm._v(" 重新註冊 ")]) : _vm._e(), _vm.showDeleteButton ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handlePermanentDelete
    }
  }, [_c('i', {
    staticClass: "mdi mdi-delete"
  }), _vm._v(" 永久刪除 ")]) : _vm._e(), _vm.showSoftDeleteButton ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-warning"
    },
    on: {
      "click": _vm.handleSoftDelete
    }
  }, [_c('i', {
    staticClass: "mdi mdi-minus-circle"
  }), _vm._v(" 刪除會員 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_EDIT_VERRIFY_PHONE) ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function click($event) {
        _vm.phoneNumberToVerify = _vm.customer.mobile_phone;
        _vm.$refs['modal-manually-verify-phone'].show();
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-cellphone"
  }), _vm._v(" 驗證手機 ")]) : _vm._e(), _vm.merchantType == 'LINE' && _vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_EDIT_RESET) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "m-1",
    attrs: {
      "variant": "outline-danger",
      "title": "重設此帳號，並刪除所有綁定"
    },
    on: {
      "click": function click($event) {
        return _vm.handleReset(_vm.customer);
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-autorenew"
  }), _vm._v(" 刪除所有綁定 ")]) : _vm._e(), _vm.showUnbindButton && _vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_EDIT_UNBIND) && _vm.merchantType !== 'LINE' ? [_c('span', {
    attrs: {
      "id": "unbind-".concat(_vm.customer.id)
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "disabled": _vm.merchantType == 'LINE'
    },
    on: {
      "click": function click($event) {
        return _vm.handleUnbind(_vm.customer);
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-link-off"
  }), _vm._v("解除綁定 ")])], 1), _vm.merchantType == 'LINE' ? _c('b-tooltip', {
    attrs: {
      "target": "unbind-".concat(_vm.customer.id),
      "placement": "top"
    }
  }, [_vm._v("LINE 通路無法解除綁定")]) : _c('b-tooltip', {
    attrs: {
      "target": "unbind-".concat(_vm.customer.id),
      "placement": "top"
    }
  }, [_vm._v("解除此帳號的綁定")])] : _vm._e()], 2)])]), _c('b-modal', {
    ref: "modal-manually-verify-phone",
    attrs: {
      "title": "手機驗證"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")]), _c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-primary",
            "size": "sm",
            "disabled": !_vm.phoneNumberToVerify
          },
          on: {
            "click": function click($event) {
              return _vm.handleManuallyVerifyPhoneIsClicked(_vm.phoneNumberToVerify);
            }
          }
        }, [_vm._v(" 確定 ")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.isVerifyingPhone
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "m",
      "label": "手機號碼"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.phoneNumberToVerify,
      callback: function callback($$v) {
        _vm.phoneNumberToVerify = $$v;
      },
      expression: "phoneNumberToVerify"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }